module.exports = __webpack_public_path__ + "img/menu-shouquan1.ae9614bf.svg";